// https://webpack.js.org/guides/public-path/#on-the-fly
import { getDisyNamespace } from '@disy/lib/disy';

// @ts-expect-error - Webpack uses this internally.
window.__webpack_public_path__ = `${getDisyNamespace().contextPath}/bundles/`;
